export var QueryKeys = /*#__PURE__*/ function(QueryKeys) {
    QueryKeys["LegalTerms"] = "LegalTerms";
    QueryKeys["LegalTermsBuilderSession"] = "LegalTermsBuilderSession";
    QueryKeys["SigningSession"] = "SigningSession";
    QueryKeys["SignatureFieldLayout"] = "SignatureFieldLayout";
    QueryKeys["SignatureDocumentUrl"] = "SignatureDocumentUrl";
    QueryKeys["Relationship"] = "Relationship";
    QueryKeys["Draft"] = "Draft";
    QueryKeys["ArchivedProposals"] = "ArchivedProposals";
    QueryKeys["CanResyncQbo"] = "CanResyncQbo";
    QueryKeys["CanResyncXero"] = "CanResyncXero";
    QueryKeys["ServiceTemplatesForBilling"] = "ServiceTemplatesForBilling";
    QueryKeys["Clients"] = "Clients";
    QueryKeys["CustomerDetail"] = "CustomerDetail";
    QueryKeys["ClientContacts"] = "ClientContacts";
    QueryKeys["RecentAgreements"] = "RecentAgreements";
    QueryKeys["Contacts"] = "Contacts";
    QueryKeys["ContactSummaries"] = "ContactSummaries";
    QueryKeys["ContactSummary"] = "ContactSummary";
    QueryKeys["ContactsMap"] = "ContactsMap";
    QueryKeys["ActiveServices"] = "ActiveServices";
    QueryKeys["ProposalTemplate"] = "ProposalTemplate";
    QueryKeys["ProposalTemplates"] = "ProposalTemplates";
    QueryKeys["ServiceBillingDetails"] = "ServiceBillingDetails";
    QueryKeys["GetInfo"] = "getInfo";
    QueryKeys["PromptSuggestions"] = "PromptSuggestions";
    QueryKeys["RichText"] = "RichText";
    QueryKeys["PdfUrl"] = "PdfUrl";
    QueryKeys["BillingSchedule"] = "BillingSchedule";
    QueryKeys["BillingTimeline"] = "BillingTimeline";
    QueryKeys["AmendmentTimelinePreview"] = "AmendmentTimelinePreview";
    QueryKeys["UserReferral"] = "UserReferral";
    QueryKeys["PayoutsSummary"] = "PayoutsSummary";
    QueryKeys["SalesSummary"] = "SalesSummary";
    QueryKeys["HistoricAgreementStats"] = "HistoricAgreementStats";
    QueryKeys["MonthlyEarnings"] = "MonthlyEarnings";
    QueryKeys["HistoricRevenueStats"] = "HistoricRevenueStats";
    QueryKeys["InvoicesDigest"] = "InvoicesDigest";
    QueryKeys["Drafts"] = "Drafts";
    QueryKeys["DraftsAiSearchResults"] = "DraftsAiSearchResults";
    QueryKeys["AgreementServiceNames"] = "AgreementServiceNames";
    QueryKeys["DraftServiceNames"] = "DraftServiceNames";
    QueryKeys["AgreementsAiSearchResults"] = "AgreementsAiSearchResults";
    QueryKeys["ActivityLog"] = "ActivityLog";
    QueryKeys["ActivityLogPreferences"] = "ActivityLogPreferences";
    QueryKeys["CustomPageTemplates"] = "CustomPageTemplates";
    QueryKeys["CustomPageText"] = "CustomPageText";
    QueryKeys["CustomPageDownloadUrl"] = "CustomPageDownloadUrl";
    QueryKeys["Invoice"] = "Invoice";
    QueryKeys["InvoiceDashboardPreferences"] = "InvoiceDashboardPreferences";
    QueryKeys["InvoiceMetrics"] = "InvoiceMetrics";
    QueryKeys["NotificationSettings"] = "NotificationSettings";
    QueryKeys["PayoutInvoices"] = "PayoutInvoices";
    QueryKeys["QboClasses"] = "QboClasses";
    QueryKeys["QboItems"] = "QboItems";
    QueryKeys["XeroItems"] = "XeroItems";
    QueryKeys["QboCustomers"] = "QboCustomers";
    QueryKeys["XeroCustomers"] = "XeroCustomers";
    QueryKeys["TeamInvites"] = "TeamInvites";
    QueryKeys["ServiceTemplates"] = "ServiceTemplates";
    QueryKeys["ServiceTemplateBundles"] = "ServiceTemplateBundles";
    QueryKeys["QboTimeActivities"] = "QboTimeActivities";
    QueryKeys["PersonaKYBStatus"] = "PersonaKYBStatus";
    QueryKeys["Integrations"] = "Integrations";
    QueryKeys["IntegrationsSummary"] = "IntegrationsSummary";
    QueryKeys["TasksJobs"] = "TasksJobs";
    QueryKeys["BulkSendResults"] = "BulkSendResults";
    QueryKeys["InvoiceDraftDates"] = "InvoiceDraftDates";
    QueryKeys["BillingControlData"] = "BillingControlData";
    QueryKeys["IsLastOwner"] = "IsLastOwner";
    QueryKeys["AdHocScheduledData"] = "AdHocScheduledData";
    QueryKeys["InvoiceDraftByDate"] = "InvoiceDraftByDate";
    QueryKeys["RelationshipSummaries"] = "RelationshipSummaries";
    QueryKeys["Invoices"] = "Invoices";
    QueryKeys["Payouts"] = "Payouts";
    QueryKeys["ClientBillingOverview"] = "ClientBillingOverview";
    QueryKeys["ClientFutureInvoices"] = "ClientFutureInvoices";
    QueryKeys["CustomerPaymentMethods"] = "CustomerPaymentMethods";
    QueryKeys["ClientPaymentMethods"] = "ClientPaymentMethods";
    QueryKeys["ReferenceFields"] = "ReferenceFields";
    QueryKeys["ReferenceFieldNames"] = "ReferenceFieldNames";
    QueryKeys["ReferenceFieldValueInUse"] = "ReferenceFieldValueInUse";
    QueryKeys["SalesTaxConfig"] = "SalesTaxConfig";
    QueryKeys["SalesTaxComponents"] = "SalesTaxComponents";
    QueryKeys["InvoiceTaxPreview"] = "InvoiceTaxPreview";
    QueryKeys["ClientTaxExemptionCertificateUrl"] = "ClientTaxExemptionCertificateUrl";
    QueryKeys["RefundState"] = "RefundState";
    QueryKeys["CalculateRefundPerLine"] = "CalculateRefundPerLine";
    QueryKeys["DraftsAiSearchState"] = "DraftsAiSearchState";
    QueryKeys["AgreementsAiSearchState"] = "AgreementsAiSearchState";
    QueryKeys["PulseOpportunities"] = "PulseOpportunities";
    QueryKeys["ArvBenchmark"] = "ArvBenchmark";
    QueryKeys["MintedProposalLinks"] = "MintedProposalLinks";
    QueryKeys["AccountingTaxRates"] = "AccountingTaxRates";
    QueryKeys["CurrentBulkRun"] = "CurrentBulkRun";
    QueryKeys["BulkRunRecipients"] = "BulkRunRecipients";
    QueryKeys["BulkRunPricing"] = "BulkRunPricing";
    QueryKeys["BulkRunResults"] = "BulkRunResults";
    QueryKeys["TemplateValidity"] = "TemplateValidity";
    QueryKeys["APIKeys"] = "APIKeys";
    QueryKeys["RemainingCreditReport"] = "RemainingCreditReport";
    QueryKeys["RemainingCreditReportFilters"] = "RemainingCreditReportFilters";
    QueryKeys["RevenueBreakdownReport"] = "RevenueBreakdownReport";
    QueryKeys["RevenueBreakdownReportFilters"] = "RevenueBreakdownReportFilters";
    QueryKeys["ActiveServicesReport"] = "ActiveServicesReport";
    QueryKeys["ActiveServicesReportFilters"] = "ActiveServicesReportFilters";
    QueryKeys["FutureInvoicesReport"] = "FutureInvoicesReport";
    QueryKeys["FutureInvoicesReportFilters"] = "FutureInvoicesReportFilters";
    QueryKeys["ProposalsReport"] = "ProposalsReport";
    QueryKeys["AnchorBilling"] = "AnchorBilling";
    QueryKeys["TeamMembers"] = "TeamMembers";
    return QueryKeys;
}({});
